import { render, staticRenderFns } from "./handl.vue?vue&type=template&id=6b5d614b&scoped=true&"
var script = {}
import style0 from "./handl.vue?vue&type=style&index=0&id=6b5d614b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d614b",
  null
  
)

export default component.exports